import { useLang } from "@/context/LanguageContext";
import { useSectionMeta } from "@/context/SiteConfigContext";
import { SectionHead, SectionButtons } from "@/components/site/primitives";
import { Reveal } from "@/components/site/Reveal";

export default function KooltExecutionArm() {
  const { t } = useLang();
  const c = t.koolt || {};
  const meta = useSectionMeta("koolt");

  return (
    <section
      id="koolt"
      data-testid="koolt-execution-arm"
      className="bg-noir text-paper px-6 md:px-12 lg:px-20 py-28 md:py-40"
    >
      <SectionHead label={c.label} index="" dark />

      <div className="mt-10 md:mt-16 grid grid-cols-12 gap-6 md:gap-10 items-start">
        <div className="col-span-12 lg:col-span-7">
          {c.lead && (
            <Reveal>
              <p className="serif italic text-xl md:text-2xl text-paper/60 mb-6">{c.lead}</p>
            </Reveal>
          )}
          <Reveal>
            <h2 className="display uppercase leading-[0.85] text-[13vw] md:text-[9vw] lg:text-[7vw] break-words">
              {c.title}
            </h2>
          </Reveal>
        </div>

        <div className="col-span-12 lg:col-span-5 lg:pt-4">
          {c.body && (
            <Reveal>
              <p className="text-base md:text-lg leading-[1.65] text-paper/75 mb-10">{c.body}</p>
            </Reveal>
          )}
          <Reveal>
            <SectionButtons buttons={meta.buttons} dark />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
